"use client";

import getSession from "@/modules/session";
import { datadogLogs } from "@datadog/browser-logs";

type Context = Record<string, unknown>;

const isServer = typeof window === "undefined";

async function log(
  level: "info" | "warn" | "error",
  message: string,
  error?: Error,
  extraContext?: Context,
): Promise<void> {
  if (isServer) {
    return;
  }

  const session = await getSession();
  const context = { userId: session?.user?.id, ...extraContext };
  switch (level) {
    case "info":
      datadogLogs.logger.info(message, context, error);
      break;
    case "warn":
      datadogLogs.logger.warn(message, context, error);
      break;
    case "error":
      datadogLogs.logger.error(message, context, error);
      break;
  }
}

export const logger = {
  info: (message: string, context?: Context) =>
    log("info", message, undefined, context),
  warn: (message: string, context?: Context) =>
    log("warn", message, undefined, context),
  error: (message: string, context?: Context, error?: Error) =>
    log("error", message, error, context),
};
